<template>
  <v-navigation-drawer app width="220" v-model="drawer" permanent>
    <div class="d-flex align-center flex-column">
      <img
        src="../assets/images/logo.png"
        width="100%"
        height="66px"
        class="pa-2"
      />
    </div>
    <v-divider></v-divider>
    <v-list dense nav>
      <template v-for="(item, i) in items">
        <v-list-item
          :class="active(item)"
          v-if="item.active"
          @click="open(item)"
          :key="i"
          link
        >
          <v-list-item-avatar height="20" width="25" tile min-width="25">
            <v-icon :class="active(item)" class="mb-1">
              {{ item.icon }}
            </v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title :class="active(item)" class="subtitle-2">{{
              item.title
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
      <v-list-group v-model="isActive">
        <template v-slot:activator>
          <v-list-item-avatar height="20" width="25" tile min-width="25">
            <v-icon class="mb-1"> mdi-face-agent</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="subtitle-2">Support</v-list-item-title>
          </v-list-item-content>
        </template>
        <v-list-item dense @click="openPhone">
          <v-list-item-avatar
            tile
            height="20"
            class="mr-0 ml-2 mr-1"
            width="25"
            min-width="25"
          >
            <v-icon size="16" color="blue" class="mb-1"> mdi-phone </v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="body-2">{{ help }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item dense @click="openWhatsapp">
          <v-list-item-avatar
            height="20"
            class="mr-0 ml-2 mr-1"
            width="25"
            min-width="25"
          >
            <v-icon size="18" class="mb-1" color="green"> mdi-whatsapp </v-icon>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title class="body-2">{{ help }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { PLAY_STORE_URL } from "../assets/js/common";
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isAuth: false,
      drawer: false,
      isActive: true,
    };
  },
  watch: {
    value(val) {
      this.drawer = val;
    },
  },
  computed: {
    help() {
      let { HelpLine_Number } = this.$store.getters.dashboard;
      return HelpLine_Number ? HelpLine_Number : "";
    },
    items() {
      let list = [
        {
          title: "Dashboard",
          path: "/",
          icon: "mdi-view-dashboard",
          name: "index",
          active: true,
        },
        {
          title: "Recharge",
          path: "/recharge",
          icon: "mdi-receipt",
          name: "recharge",
          active: true,
        },
        {
          title: "Shopping",
          path: "/shopping",
          icon: "mdi-shopping",
          name: "shopping",
          active: true,
        },
        {
          title: "Reports",
          path: "/reports",
          name: "reports",
          icon: "mdi-poll",
          active: true,
        },
        {
          title: "Settings",
          path: "/settings",
          icon: "mdi-cog",
          name: "settings",
          active: this.websiteType !== "nologin",
        },
        {
          title: "Android App",
          path: PLAY_STORE_URL,
          icon: "mdi-google-play",
          name: "android",
          active: true,
        },
      ];
      return list;
    },
    user() {
      return this.$store.getters.user;
    },
    isAdmin() {
      let { role } = this.$store.getters.user;
      return role == 1 || role == 2;
    },
    isTemporary() {
      return window.innerWidth < 1200;
    },
  },
  methods: {
    openWhatsapp() {
      window.open(
        `https://wa.me/91${this.help}?text=Support-Request-Call-Initiated`
      );
    },
    openPhone() {
      window.open(`tel:+91${this.help}`);
    },
    active({ path }) {
      return this.$route.path === path ? "primary white--text" : "";
    },
    open({ path, name }) {
      if (name == "android") {
        window.open(path);
      } else {
        this.$router.push(path);
      }
    },
  },
};
</script>

